import * as React from "react";
import styled from "styled-components";

export interface ProofBarItem {
  /** KLASA IKONY FONT AWESOME 4 (NP. "fa fa-calendar") */
  iconClassName: string

  /** KRÓTKI DOWÓD (NP. "od 2014 r.") */
  text: string

  /** LINK DO DOWODU => PUSTY = BEZ LINKU */
  link?: string
}

interface ProofBarBlockProps {
  /** KRÓTKIE DOWODY Z IKONAMI => ROZDZIELANE KROPKĄ */
  proofs: ProofBarItem[]
}

const ProofBarBlock = (props: ProofBarBlockProps) => {
  const {proofs} = props;

  // ZWRACANIE DANYCH
  return (
    <ProofBarWrapper>
      {proofs.map((proof: ProofBarItem, index: number) => {
        const content = [
          <i key="icon" className={proof.iconClassName} aria-hidden="true"/>,
          proof.text
        ];
        return (
          <span key={index}>
            {proof.link
              ? <a href={proof.link} target="_blank" rel="noopener noreferrer">{content}</a>
              : content}
          </span>
        );
      })}
    </ProofBarWrapper>
  )
};

/** STYLES */

const ProofBarWrapper = styled.p`
  margin: 0;
  padding: 18px 20px;
  background: #f5f5f5;
  color: #424242;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  span {
    display: inline-block;
    white-space: nowrap;
  }
  /* KROPKA ZA ELEMENTEM (NIE PRZED) => PRZY ZAWIJANIU NIE ZACZYNA NOWEJ LINII */
  span:not(:last-child):after {
    content: "·";
    margin: 0 10px;
  }
  /* WĄSKI EKRAN => DOWODY JEDEN POD DRUGIM, BEZ KROPEK */
  @media (max-width: 414px) {
    span {
      display: block;
    }
    span + span {
      margin-top: 6px;
    }
    span:not(:last-child):after {
      content: none;
    }
  }
  i {
    margin-right: 7px;
    color: #03a9f4;
  }
  a {
    color: #1976d2;
    text-decoration: underline;
  }
  a i {
    text-decoration: none;
  }
`;

export default ProofBarBlock



// WEBPACK FOOTER //
// ./src/layouts/proof-bar-block/proof-bar-block.tsx